//#region src/user-identity.manager.tsx
/**
* initialises the userIdentityManager with actual integrations of the login
* and logout process.
*
* NB: Once a user has been fully loaded it should be applied using the
* accompanying redux state.
*/
function configureUserIdentityManager(config) {
	userIdentityManager.logout = config.logout;
	userIdentityManager.requestLogin = config.requestLogin;
}
var userIdentityManager = {
	requestLogin: () => {
		console.warn("UserIdentityManager has not beed configured yet, a call to configureUserIdentityManager() is required before accessing manager.requestLogin()");
	},
	logout: () => {
		console.warn("UserIdentityManager has not beed configured yet, a call to configureUserIdentityManager() is required before accessing manager.logout()");
	}
};
//#endregion
export { configureUserIdentityManager, userIdentityManager };

//# sourceMappingURL=user-identity.manager.js.map